import React, { useContext } from 'react';
import { func } from 'prop-types';
import _ from 'lodash'; // eslint-disable-line

// Nucleus Components
import { extend } from '@thd-nucleus/data-sources';
import { Button } from '@thd-olt-component-react/core-ui';
import {
  RentalEstimate,
  RentalEstimateWrapperProvider
} from '@thd-olt-component-react/rental-estimate';

// Local Components
import { ReservationContext } from '../../../context/reservation-context';
import { ReservationLookupApiContext } from '../../../context/ReservationLookupApiContext';
import { FeatureSwitchContext } from '../../../context/feature-switch-context';
import { FormSection } from '../../../components/form-section/form-section';
import { CurrentTimes } from '../../../components/current-times/current-times';
import { StoreDetails, StoreDetailsPlaceholder } from '../../../components/store-details/store-details';
import { convertTimestampForEstimate } from '../../../utils/mapper';

// CSS
import './landing.scss';
import '../reservation-modify-form.scss';

export const Landing = ({ showCancel, showModifyFlow }) => {

  const [reservationState, dispatch] = useContext(ReservationContext);
  const { data } = useContext(ReservationLookupApiContext);
  const { estimateGraphQlEnabled } = useContext(FeatureSwitchContext);

  const { reservationModifyStore } = reservationState;

  return (
    <div className="modify-landing">
      <FormSection identifier="DaysAndTimes" display title="Location">
        <div className="store-details-container">
          {!_.isEmpty(reservationModifyStore) ? (
            <StoreDetails store={reservationModifyStore} />
          ) : <StoreDetailsPlaceholder /> }
        </div>
      </FormSection>
      <FormSection identifier="DaysAndTimes" display title="Days and Times">
        <CurrentTimes />
      </FormSection>
      <FormSection identifier="RentalEstimate" display={!_.isEmpty(data)} title="Rental Estimate">
        {!_.isEmpty(data) ? (
          <RentalEstimateWrapperProvider
            pickupTime={convertTimestampForEstimate(data?.pickup_time)}
            returnTime={convertTimestampForEstimate(data?.return_time)}
            storeId={data?.store_number}
            rentalCategory={_.first(data?.tools)?.category_code}
            rentalSubCategory={_.first(data?.tools)?.subcategory_code}
            damageProtection={data?.damage_protection || false}
            graphQlEnabled={estimateGraphQlEnabled}
            hideDeposit // TODO: make this lookup login and SVOC_ID if possible
          >
            <RentalEstimate />
          </RentalEstimateWrapperProvider>
        ) : <>&nbsp;</>}
      </FormSection>
      <FormSection identifier="SummaryActions" display title="">
        {
          (!_.isEmpty(data) && _.isEmpty(data.customer_modification_disabled_status)) ? (
            <>
              <Button onClick={() => showModifyFlow()}>Modify Reservation</Button>
              <br />
              <Button onClick={() => showCancel()} outline>Cancel Reservation</Button>
            </>
          ) : (
            <Button onClick={() => showCancel()}>Cancel Reservation</Button>
          )
        }
      </FormSection>
    </div>
  );
};

Landing.propTypes = {
  showCancel: func.isRequired,
  showModifyFlow: func.isRequired
};

Landing.dataModel = extend(RentalEstimateWrapperProvider);